/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
    'use strict';

    /**
     * Вид для групп форм доставки
     */
    app.JointPurchaseDeliveryGroupFormsView = app.View.extend({
        listSelector: '',

        jpSettlementIds: [],

        run: function (options) {
            if (options && options.groups) {
                this.groups = options.groups;
            }
            if (options && options.settlement) {
                this.settlement = options.settlement;
            } else {
                this.settlement = null;
            }
            var that = this;
            this.childViews = {};
            this.jpDistrictModels = new app.Districts();
            this.childViews.formViews = [];
            this.$(this.listSelector).html('');
            _.each(this.groups, function (group) {
                that.renderNewDeliveryGroupForm(group.settlement, group.districts, group.deliveries);
            });
        },

        /**
         * Добавляет новую группу доставки
         */
        addDeliveryGroupCity: function () {
            var group, check, settlement_id;
            if (!this.settlement) {
              return;
            }
            settlement_id = this.settlement.get('settlement_id');
            check = this.groups.some(function (group) {
                return (group.settlement.id || group.settlement.settlement_id) == settlement_id;
            });
            group = {
                settlement: check ? null : (this.settlement && this.settlement.toJSON()),
                districts: null,
                deliveries: []
            };
            this.groups.push(group);
            this.renderNewDeliveryGroupForm(group.settlement, group.districts, group.deliveries);
        },

        /**
         * Обновляет данные по доставке
         */
        updateGroupsData: function() {
            var that = this;
            this.groups = [];
            if (this.jpSettlementIds.length) {
                this.jpSettlementIds.splice(0, this.jpSettlementIds.length);
            }
            _.each(this.childViews.formViews, function (view) {
                if (view.model.length && view.settlement) {
                    that.groups.push({
                        settlement: view.settlement,
                        districts: view.districts.toJSON(),
                        deliveries: view.model.toJSON()
                    });
                    that.jpSettlementIds.push(view.settlement.id || view.settlement.settlement_id);
                }
            });
        },

        /**
         * Метод для вызова метода save у всех дочерних вью.
         */
        validateAll: function () {
            var deferred = [];
            this.updateGroupsData();
            if (this.childViews.formViews.length) {
                this.childViews.formViews.forEach(function (view) {
                    if (!view.isRemoved) {
                        deferred.push(view.validateAll());
                    }
                });
                return $.when.apply($, deferred);
            } else {
                return;
            }
        }
    });
})();

}.call(window));